import '../../user-common-js';

import '../../../source/javascripts/reminder';
import '../../../source/javascripts/autologin_tip';



// WEBPACK FOOTER //
// ./es6/user-page-js/main/login.page.js